import React from 'react';
import {Container1, Container2} from './styles';

export default function DeclaracaoDePrivacidade(){
    return <Container1>
        <Container2>
            <header>Declaração de Privacidade</header>
            <p>Data de atualização: 15/09/2022</p>
            <p>
            O Trabs é um aplicativo que tem como objetivo acompanhar a satisfação e sentimentos dos trabalhadores da saúde. Faz parte do <a rel='noreferrer' target='_blank' href='http://saudedotrabalhador.ufpb.br/' >Observatório da Saúde do Trabalhador.</a>
            </p>
            <p>Essa Declaração de Privacidade descreve como obtemos, armazenamos, utilizamos, compartilhamos e protegemos as suas informações.</p>
            <ol start={1}>
                <li><span>Quais dados são coletados?</span></li>
            </ol>
            <p>Ao criar uma conta no Trabs, as seguintes informações são solicitadas para efetivação do cadastro: nome, ano de nascimento, sexo, e-mail, profissão, UF e cidade. De forma dinâmica, informações sobre sentimentos são coletadas. Para cada sentimento, a saber: apoiado(a), alegre, triste, medo, raiva, adoecido(a) e reconhecido(a), é indicada a intensidade em uma escala de 1 a 5 e o respectivo motivo. A satisfação com o trabalho é coletada em uma escala de Muito insatisfeito(a) para Muito satisfeito(a), incluindo o respectivo motivo. As datas dos registros são coletadas. </p>
            <ol start={2}>
                <li>Por que coletamos os seus dados?</li>
            </ol>
            <p>Os dados sobre sentimentos e satisfação são utilizados para análise de forma agrupada sem identificação individual e visualizados no <a rel='noreferrer' target='_blank' href='http://saudedotrabalhador.ufpb.br/' >Observatório da Saúde do Trabalhador</a>. </p>
            <ol  start={3}>
                <li>Como protegemos os seus dados?</li>
            </ol>
            <p>Os dados pessoais são protegidos de acessos não autorizados e de situações acidentais ou ilícitas através de técnicas de criptografia e monitoramento.</p>
            <ol  start={4}>
                <li>Como os dados são armazenados?</li>
            </ol>
            <p>Os dados são armazenados em um servidor no Brasil com acesso restrito.</p>
            <ol  start={5}>
                <li>Como os dados são compartilhados?</li>
            </ol>
            <p>Os dados individuais não são compartilhados com terceiros. Os dados agrupados são disponibilizados exclusivamente no <a rel='noreferrer' target='_blank' href='http://saudedotrabalhador.ufpb.br/' >Observatório da Saúde do Trabalhador</a>.</p>
            <ol  start={6}>
                <li>Como utilizamos outras tecnologias?</li>
            </ol>
            <p>O aplicativo é integrado com o <a rel='noreferrer' target='_blank' href='https://onesignal.com/'>OneSignal</a> para envio de notificações personalizadas considerando o UF e profissão de cada usuário com o objetivo de engajá-lo no uso periódico do aplicativo. De modo a verificar a eficácia da estratégia, são registrados os acessos ao aplicativo a partir das notificações.</p>
            <ol  start={7}>
                <li>Como notificamos as mudanças feitas nesta Declaração?</li>
            </ol>
            <p>A data da versão em vigor está disponível no início deste documento. A versão em vigor será sempre a mais recente, disponível no menu principal do aplicativo.</p>

        </Container2>
    </Container1>
}